import React, { useEffect } from "react";
import { useLocation } from "react-router";
import clsx from "clsx";
import { useTheme } from "../core";
import { DrawerComponent } from "../../assets/ts/components";

type Props = {
  children?: React.ReactNode | React.ReactNode[];
};

const Content = (props?: Props) => {
  const { config } = useTheme();
  const location = useLocation();
  useEffect(() => {
    DrawerComponent.hideAll();
  }, [location]);

  return (
    <div className={clsx({ container: config.content.layout === "default" })}>
      {props && props.children}
    </div>
  );
};

export { Content };
